import { css, setColor_25476d, setFontSize_13px, setFontWeight600, setProps, styled } from "theme";

interface SFilterSelectTitleProps {
  isArabic: boolean;
}

const isArabicLang = setProps<SFilterSelectTitleProps>(({ isArabic }) => isArabic)(css`
  text-align: right;
`);

export const SFilterSelectTitle = styled.div<SFilterSelectTitleProps>`
  margin-top: 8px;
  margin-bottom: 8px;

  ${isArabicLang};
  ${setFontSize_13px};
  ${setFontWeight600};
  ${setColor_25476d};
`;
